// extracted by mini-css-extract-plugin
export default {"tooltip":"qQ-z","arrow":"rQ-z"};